
<app-web-navbar></app-web-navbar>

<div class="main-div row col-12 col-lg-8 mt-4 mb-4 ms-auto me-auto justify-content-center">
  @if (IsNewSubscription) {
    <div class="alert alert-success alert-dismissible fade show" role="alert">
      <strong>Registration Successfull !!</strong>
      <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
      (click)="ResetNewSubscription()"></button>
    </div>
  }

  <div class="subscriber-login-header row col-12 col-lg-6 ms-0 d-none d-lg-flex order-2">
    <div class="stairs-top-left">
      <img src="../../assets/images/subscriber-login/stair-top-left.png" alt="">
    </div>

    <div class="subscriber-login-content row col-12 mt-4 ">
      <div class="subscriber-login-img mb-5 col-lg-7 ms-auto me-auto">
        <img src="../../assets/images/subscriber-login/subscriber-login-img.png" alt="">
      </div>
      <div class="subscriber-login-description row col-12 col-lg-8 ms-auto me-auto mb-4">
        <h3 class="col-12 text-center">Take control of your business today!</h3>
        <p class="col-12 text-center"> Track new sales, invoices, and important transactions. Take control of your business today!</p>
      </div>
    </div>

    <div class="stairs-bottom-right">
      <img src="../../assets/images/subscriber-login/stair-bottom-right.png" alt="">
    </div>
  </div>

  <div class="subscriber-login row col-12 col-sm-8 col-md-6 col-lg-6 mt-4 me-lg-1 ps-2 pe-0 justify-content-center order-1">
    <form class="row col-12" [formGroup]="subscriberLoginGroup"
      (ngSubmit)="Userlogin()">
      <div class="company-logo col-4">
        <img src="../../assets/images/logo/logo.png" alt="" class="col-12">
      </div>
      <div class="form-heading row col-12 mt-3 mb-3">
        <h3 class="col-12 fw-bold">Blog Login</h3>
        <p class="col-12 fw-bolder">See your growth and get sales reports</p>
      </div>

      <div class="email-div row col-12">
        <label for="blog-login-email" class="col-12 col-lg-5 ms-0">Email*</label>
        <div class="col-12 mb-3">
          <p-floatlabel>
            <input pInputText id="blog-login-email" class="w-100 mb-3" placeholder="pat@example.com" formControlName="Username" autocomplete="username" />
            <label for="blog-login-email">Email</label>
          </p-floatlabel>
          @if (subscriberLoginGroup.get('Username')?.invalid && subscriberLoginGroup.get('Username')?.touched) {
            <small class="text-danger d-block mt-1">{{ getErrorMessage() }}</small>
          }
        </div>

        <label for="blog-login-password" class="col-12 col-lg-5 ms-0">Password*</label>
        <div class="col-12 mb-3">
          <p-password inputId="blog-login-password" formControlName="Password" [toggleMask]="true" [feedback]="false"
            styleClass="w-100" inputStyleClass="w-100" placeholder="Password" autocomplete="current-password" />
        </div>
      </div>

      <div class="row col-12 mb-3 align-items-center" style="margin-left: 35px;">
        <ngx-recaptcha2 #captchaElem [siteKey]="CaptchaSiteKey" [size]="size" (success)="handleSuccess($event)" [hl]="lang" [theme]="theme" [type]="type" formControlName="recaptcha">
        </ngx-recaptcha2>
      </div>
      <div class="login-button row col-12 mb-3">
        <button class="ps-2 pe-2 pt-1 pb-1 text-center primary-button" type="submit">Login</button>

        @if (InvalidLogin) {
          <p style="text-align: center;margin-top: 4px;cursor: pointer;">
            <span style="color: red;">Invalid username or password</span>
          </p>
        }
      </div>

    </form>
  </div>
</div>

<app-web-footer></app-web-footer>
